<template>
  <li>
    <div class="review-inner">
      <p class="tit">{{ title }}</p>
      <p class="info">{{ info }}</p>
      <div class="img-wrap">
        <img :src="thumbnail" alt="review">
      </div>
      <div class="tx-wrap">
        <p class="name">{{ writer }}</p>
        <p class="date">{{ writeDateTime }}</p>
        <div class="tx-box">
          {{ content }}
        </div>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  name: "ReviewCard",
  props: ["title", "info", "writer", "writeDateTime", "content", "thumbnail"],
  methods: {}
}
</script>

<style scoped>

</style>
